import React, {useEffect, useState, useContext} from 'react'
import styled from 'styled-components';
import { GoogleMapsContext } from './GoogleMapsProvider';

declare global {
    interface Document {
      mozCancelFullScreen?: () => Promise<void>;
      msExitFullscreen?: () => Promise<void>;
      webkitExitFullscreen?: () => Promise<void>;
      mozFullScreenElement?: Element;
      msFullscreenElement?: Element;
      webkitFullscreenElement?: Element;
      onwebkitfullscreenchange?: any;
      onmsfullscreenchange?: any;
      onmozfullscreenchange?: any;
    }
  
    interface HTMLElement {
      msRequestFullScreen?: () => Promise<void>;
      mozRequestFullScreen?: () => Promise<void>;
      webkitRequestFullScreen?: () => Promise<void>;
    }
}

const ButtonFullScreen = () => {
    const {mapInstance} = useContext(GoogleMapsContext)

    const [isFullScreen, setIsFullscreen] = useState(false)

    const onClick = (e) => {
       if(isFullScreen) exitFullscreen()
       else requestFullscreen(mapInstance.getDiv())

       setIsFullscreen(!isFullScreen)
    }
      
    const requestFullscreen = (element: HTMLElement) => {
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.msRequestFullScreen) {
            element.msRequestFullScreen();
        }
    }
    
    const exitFullscreen = () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }

    return <>
        {mapInstance && <Button onClick={onClick } className="btn-full-screen">
                <i className="fas fa-expand"></i>
           </Button>}
    </>
}

export default ButtonFullScreen;

const Button = styled.button`
    border: none;
    background: ${({theme}) => theme['gray-0']};
    border-radius: 3px;
    width: 32px;
    height: 32px;
    font-size: 16px;
    color: #37a3ef;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.10);
`